/**
 * Onboarding — first-spawn keyboard hint overlay.
 *
 * Shows for ~6 seconds then fades. Stored as a one-shot in localStorage so
 * returning players don't see it again.
 */

import { html, render } from 'lit-html';

const SEEN_KEY = 'virtuaroo:seen-onboarding';

export class Onboarding {
  private container: HTMLDivElement | null = null;

  show(): void {
    if (localStorage.getItem(SEEN_KEY)) return;
    const root = document.getElementById('ui-root');
    if (!root) return;
    this.container = document.createElement('div');
    this.container.className = 'onboarding';
    root.appendChild(this.container);
    render(
      html`
        <div class="ob-inner">
          <div class="ob-title">welcome to the farm</div>
          <div class="ob-grid">
            <div><kbd>WASD</kbd> walk</div>
            <div><kbd>Shift</kbd> run</div>
            <div><kbd>Space</kbd> jump</div>
            <div><kbd>Mouse</kbd> look (click to lock)</div>
            <div><kbd>T</kbd> chat</div>
            <div><kbd>1–9</kbd> emote</div>
            <div><kbd>V</kbd> camera</div>
            <div><kbd>M</kbd> map</div>
          </div>
        </div>
      `,
      this.container
    );
    localStorage.setItem(SEEN_KEY, '1');
    setTimeout(() => {
      if (this.container) {
        this.container.classList.add('fade');
        setTimeout(() => this.container?.remove(), 1200);
      }
    }, 6000);
  }
}
